import { render, staticRenderFns } from "./delivery-method-cards.vue?vue&type=template&id=5828aad4&scoped=true&lang=pug"
import script from "./delivery-method-cards.vue?vue&type=script&lang=ts"
export * from "./delivery-method-cards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828aad4",
  null
  
)

export default component.exports